import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { Button, Text, type TextProps, Textarea } from "metabase/ui";

export const IFrameWrapper = styled.div<{
  fade?: boolean;
  customCard?: boolean;
}>`
  position: relative;
  display: flex;
  width: 100%;
  height: ${props => (props.customCard ? "calc(100% - 2px)" : "100%")};
  background: #fff;
  align-items: center;
  border-radius: var(--default-border-radius);
  overflow: hidden;
  box-sizing: border-box;
  border: ${props =>
    props.customCard ? "1px solid #e6e6e6" : "0px solid #e6e6e6"};
  .ant-skeleton {
    position: absolute;
    left: 0;
    top: 60px;
    width: 100%;
    height: 100%;
    background: #fff;
    padding: 0 16px;
    z-index: 999;
  }
`;

export const IFrameEditWrapper = styled.div<{ fade?: boolean }>`
  padding: 0.75rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const interactiveDashcardElementCss = css`
  pointer-events: all;

  * {
    pointer-events: all;
  }
`;

export const StyledInput = styled(Textarea)`
  ${interactiveDashcardElementCss}
`;

export const SaveButton = styled(Button)`
  ${interactiveDashcardElementCss}
`;

export const InteractiveText = styled(Text)<TextProps>`
  ${interactiveDashcardElementCss}
`;

export const CustomBtnsWrapper = styled.div<{ publicType?: string }>`
  position: absolute;
  right: ${props => (props.publicType === "question" ? "72px" : "38px")};
  top: 11px;
  display: flex;
  align-items: center;
  .ant-picker-range {
    width: 230px;
  }
  .ant-btn {
    padding: 8px 7px;
  }
  .ant-picker-suffix {
    color: rgba(0, 0, 0, 0.88);
  }
`;
